import type { ImageRelationField, ImageSize, ImageVariations, RelationField } from '~/models/Content/BaseField'
import { useUrlBuilder } from '~/composables/useUrlBuilder'

export default () => {
  const getImageSrc = (imageField: ImageRelationField, variation: ImageVariations = 'banner_large'): string => {
    const { buildImageUrlByField } = useUrlBuilder()
    return imageField.uri
      || buildImageUrlByField(Number(imageField.destinationContentId), 'image', variation)
      || ''
  }

  const getSvgSrc = (svgField: RelationField): string => {
    const { buildSvgUrlByField } = useUrlBuilder()
    return buildSvgUrlByField(Number(svgField.destinationContentId))
  }

  const getImageAltText = (imageField: ImageRelationField): string => imageField.alternativeText || ''

  const getImageSizeClass = (imageSize: ImageSize) => ({
    none: 'object-none',
    contain: 'object-contain',
    cover: 'object-cover',
  })[imageSize]

  return {
    getImageSrc,
    getImageAltText,
    getImageSizeClass,
    getSvgSrc,
  }
}
